import { useRouter } from 'next/router'

import { faCoins } from '@fortawesome/pro-light-svg-icons/faCoins'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  styled,
} from '@mui/material'

import { Button } from '@/components/Button/Button'
import { Icon } from '@/shared/components/Icon/Icon'
import { useGetCreditBalance } from '@/shared/api/generated/credits/credits'
import { pxToRem } from '@/shared/styles/themes'

import type { BaseDialogProps } from './DialogContext'

export const InsufficientCreditsDialog: React.FC<BaseDialogProps> = ({
  open,
  onClose,
}) => {
  const router = useRouter()
  const { data: creditBalance } = useGetCreditBalance()

  const handleGetCredits = () => {
    onClose?.()
    router.push('/shop')
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      container={() => document.getElementById('modal')}
    >
      <DialogTitle>Insufficient Credits</DialogTitle>
      <DialogContent>
        <StyledContent>
          <StyledIconWrapper>
            <Icon icon={faCoins} sx={{ fontSize: pxToRem(48), color: 'warning.main' }} />
          </StyledIconWrapper>
          <Typography variant="body1" align="center">
            You don&apos;t have enough credits to complete this action.
          </Typography>
          {creditBalance && (
            <Typography variant="body2" align="center" color="text.secondary">
              Current balance: {creditBalance.total_balance} credits
            </Typography>
          )}
        </StyledContent>
      </DialogContent>
      <DialogActions>
        <Button text onClick={onClose}>
          Close
        </Button>
        <Button primary onClick={handleGetCredits}>
          Get More Credits
        </Button>
      </DialogActions>
    </Dialog>
  )
}

const StyledContent = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${pxToRem(16)};
  padding-top: ${pxToRem(8)};
`

const StyledIconWrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${pxToRem(16)};
`
